import { render, staticRenderFns } from "./AbkSimpleMessageForm.vue?vue&type=template&id=10c82441&scoped=true&"
import script from "./AbkSimpleMessageForm.vue?vue&type=script&lang=js&"
export * from "./AbkSimpleMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkSimpleMessageForm.vue?vue&type=style&index=0&id=10c82441&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c82441",
  null
  
)

export default component.exports